import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { AiOutlineCode, AiOutlineGithub, AiOutlineRocket } from "react-icons/ai";
import { BiGitPullRequest } from "react-icons/bi";

function CurrentWork() {
  const username = "Pranav-1100";

  return (
    <Container fluid style={{ paddingTop: "60px", paddingBottom: "60px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        What I'm <strong className="purple">Working On</strong>
      </h1>
      <p style={{ color: "white", fontSize: "1.1rem", marginBottom: "3rem", textAlign: "center" }}>
        Research, building with AI, and exploring new technologies
      </p>

      <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
        {/* Current Focus */}
        <Col md={4} className="mb-4">
          <Card className="quote-card-view" style={{ height: "100%" }}>
            <Card.Body>
              <div style={{ textAlign: "center", marginBottom: "15px" }}>
                <AiOutlineRocket style={{ fontSize: "3em", color: "#c770f0" }} />
              </div>
              <Card.Title style={{ color: "#c770f0", textAlign: "center", marginBottom: "15px" }}>
                Current Focus
              </Card.Title>
              <ul style={{ textAlign: "left", color: "white" }}>
                <li>AI safety research: how reliable LLM agents are on long, multi-step tasks</li>
                <li>Designing RL environments used to train and evaluate models</li>
                <li>Building AI-powered applications with RAG & multi-agent systems</li>
                <li>Full-stack development with modern frameworks</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>

        {/* Daily Coding */}
        <Col md={4} className="mb-4">
          <Card className="quote-card-view" style={{ height: "100%" }}>
            <Card.Body>
              <div style={{ textAlign: "center", marginBottom: "15px" }}>
                <AiOutlineCode style={{ fontSize: "3em", color: "#c770f0" }} />
              </div>
              <Card.Title style={{ color: "#c770f0", textAlign: "center", marginBottom: "15px" }}>
                Latest Research
              </Card.Title>
              <div style={{ textAlign: "center", color: "white" }}>
                <p>Sole-author AI safety paper on arXiv</p>
                <h2 style={{ color: "#c770f0", fontSize: "2.2em", margin: "10px 0" }}>12 models</h2>
                <p style={{ fontSize: "1.05em" }}>tested, plus a 3B model trained to fix the failure</p>
                <p style={{ marginTop: "15px" }}>
                  <a href="https://arxiv.org/abs/2608.27167" target="_blank" rel="noopener noreferrer" style={{ color: "#c770f0" }}>
                    Read the paper
                  </a>
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Open to Collaborate */}
        <Col md={4} className="mb-4">
          <Card className="quote-card-view" style={{ height: "100%" }}>
            <Card.Body>
              <div style={{ textAlign: "center", marginBottom: "15px" }}>
                <BiGitPullRequest style={{ fontSize: "3em", color: "#c770f0" }} />
              </div>
              <Card.Title style={{ color: "#c770f0", textAlign: "center", marginBottom: "15px" }}>
                Open to Collaborate
              </Card.Title>
              <ul style={{ textAlign: "left", color: "white" }}>
                <li>AI/ML projects & research</li>
                <li>Full-stack web applications</li>
                <li>Mobile app development</li>
                <li>Open source contributions</li>
              </ul>
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <a
                  href={`https://github.com/${username}`}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "#c770f0",
                    textDecoration: "none",
                    fontSize: "1.1em",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px"
                  }}
                >
                  <AiOutlineGithub /> View my GitHub
                </a>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default CurrentWork;
